export const serverModelToInputModelConverter = ({ hotelID }: { hotelID: string }) => {
	return { hotelID, paymentToken: undefined, hasPayjpValidation: true };
};
